<script setup>
const emit = defineEmits(['success', 'update:modelValue'])
const route = useRoute()

defineProps({
  stacked: {
    type: Boolean,
    default: false
  },
  cta: {
    type: String,
    default: 'Sign Up'
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const email = ref(route.query?.email)

watch(() => route.query, (query) => {
  if (query?.email) {
    email.value = query.email
  }
})

function clear () {
  email.value = ''
}

function setEmail (value) {
  email.value = value
}

defineExpose({ clear, setEmail })
</script>

<template>
  <form
    class="relative flex w-full flex-col items-center gap-4"
    :class="{ 'md:flex-row': !stacked }"
    @submit.prevent="emit('success', email)">
    <InlineSvg
      hard-code
      src="/images/icon-envelope.svg"
      class="absolute left-3 top-[16px] size-6 fill-current text-body-gray" />

    <FormInput
      v-model="email"
      type="email"
      name="email"
      required
      placeholder="Enter your email"
      class="w-full flex-1"
      input-class="pl-11" />
    <button
      :disabled="loading"
      class="btn-primary inline-flex items-center gap-2 self-stretch px-10 py-4 disabled:opacity-50">
      <span>{{ loading ? 'Loading...' : cta }}</span> <slot name="buttonIcon" />
    </button>
  </form>
</template>
